export class CourtName {
    courtnameid: number;
    courtname: string;
    courtid: number;
    createdby: number;
    createdon: string;
    modifiedby: number;
    modifiedon: string;
    active: number;
}

